module.exports = __webpack_public_path__ + "img/home-img-3.8efcadef.png";